export const MAX_ENTRIES = 50
const scrollPositions = new Map<string, number>()

/**
 * Save the scroll position for a given route path.
 * Evicts the oldest entry if the map exceeds MAX_ENTRIES.
 * @param routePath
 * @param scrollTop
 */
export function saveScrollPosition(routePath: string, scrollTop: number) {
  // Delete first so re-inserting moves it to the end (most recent)
  scrollPositions.delete(routePath)
  scrollPositions.set(routePath, scrollTop)

  if (scrollPositions.size > MAX_ENTRIES) {
    const oldestKey = scrollPositions.keys().next().value
    if (oldestKey !== undefined) {
      scrollPositions.delete(oldestKey)
    }
  }
}

/**
 * Get the saved scroll position for a given route path.
 * @param routePath
 */
export function getSavedScrollPosition(routePath: string): number | undefined {
  return scrollPositions.get(routePath)
}

/**
 * Clear all saved scroll positions. Useful for testing.
 */
export function clearScrollPositions() {
  scrollPositions.clear()
}
